import { defineComponent as _defineComponent } from 'vue'
import { AxiosError } from 'axios';
import { BProgress } from 'bootstrap-vue';
import { onMounted, onUnmounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import i18n from '@/initI18n';

import Button from '@/shared/components/buttons/Button.vue';
import { CNH_STATE_KEY } from '@/shared/constants';

import useActivitiesImports from '../composables/useActivitiesImport';
import useCnhActivityImport from '../composables/useCnhActivityImport';
import useCnhImport from '../composables/useCnhImport';
import ImportLoadDataCnhFilterForm from './ImportLoadDataCnhFilterForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportLoadDataCnh',
  setup(__props) {

const $t = i18n.translate;

const route = useRoute();
const router = useRouter();
const { goNext } = useActivitiesImports();
const { cnhLogin, cnhErrorResponseHandler } = useCnhImport();
const {
  pollingInProgress,
  importProgress,
  stopPollingImportStatus,
  cnhImportStatus,
  resetImport,
  startPollingImportStatus,
  importStatus,
  importErrorMessage,
} = useCnhActivityImport();

/* METHODS */

function isCorrectState() {
  return localStorage.getItem(CNH_STATE_KEY) === route.query.state;
}

async function checkImportStatus() {
  try {
    const importStatusResponse = await cnhImportStatus();
    if (importStatusResponse.data.data?.status === 'Pending') {
      startPollingImportStatus();
    } else {
      resetImport();
    }
  } catch (error) {
    console.error(error);
  }
}

/* WATCH */
watch(importStatus, (newImportStatus) => {
  if (newImportStatus === 'Ready' || newImportStatus === 'PartialError') {
    setTimeout(() => router.push({ name: 'activities/import/import-table' }), 1000);
  }
});

/* LIFECYCLE HOOKS */

onMounted(async () => {
  const authCode = route.query.code as string;
  const { state } = route.query;
  if (authCode && state) {
    if (isCorrectState()) {
      try {
        const loginResponse = await cnhLogin(authCode);
        if (loginResponse.status === 200) {
          localStorage.removeItem(CNH_STATE_KEY);
        }
      } catch (error) {
        cnhErrorResponseHandler(error as AxiosError);
      }
    } else {
      console.error('state is not correct');
      router.push({ name: 'activities-import' });
    }
  }

  checkImportStatus();
});

onUnmounted(() => {
  stopPollingImportStatus();
});

return { __sfc: true,$t, route, router, goNext, cnhLogin, cnhErrorResponseHandler, pollingInProgress, importProgress, stopPollingImportStatus, cnhImportStatus, resetImport, startPollingImportStatus, importStatus, importErrorMessage, isCorrectState, checkImportStatus, BProgress, Button, ImportLoadDataCnhFilterForm }
}

})